export enum CreditCard {
  VISA = '1',
  MASTERCARD = '2',
  JCB = '3',
  AMERICAN_EXPRESS = '4',
  DINERS_CLUB = '5',
  OTHERS = '6',
}
